import React from 'react';
import { Download, Trash2, Edit2 } from 'lucide-react';
import { motion } from 'framer-motion';
import BarChart from './BarChart';
import LineChart from './LineChart';
import PieChart from './PieChart';
import ScatterChart from './ScatterChart';
import MetricCard from './MetricCard';
import TableChart from './TableChart';

const ChartContainer = ({
  visualization,
  data,
  onEdit,
  onDelete,
  onExport,
  isEditable = true
}) => {
  if (!visualization || !data) {
    return <div className="text-sand-700 p-8 text-center">No data available</div>;
  }

  const chartType = visualization.chart_type;
  const config = visualization.chart_config || {};

  const renderChart = () => {
    const props = { data, config, title: visualization.name };

    switch (chartType) {
      case 'bar':
        return <BarChart {...props} />;
      case 'line':
        return <LineChart {...props} />;
      case 'pie':
        return <PieChart {...props} />;
      case 'scatter':
        return <ScatterChart {...props} />;
      case 'metric':
        return <MetricCard {...props} />;
      case 'table':
        return <TableChart {...props} />;
      default:
        return <TableChart {...props} />;
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white border border-[rgba(32,30,29,0.12)] shadow-brand-sm rounded-xl p-6 space-y-4"
    >
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-ink font-semibold text-lg">{visualization.name}</h3>
          {visualization.description && (
            <p className="text-sand-700 text-sm">{visualization.description}</p>
          )}
        </div>

        {isEditable && (
          <div className="flex gap-2">
            <button
              onClick={() => onExport && onExport(visualization)}
              className="p-2 rounded-lg bg-bill-100 text-bill-700 hover:bg-bill-200 transition-colors"
              title="Export"
            >
              <Download className="w-4 h-4" />
            </button>
            <button
              onClick={() => onEdit && onEdit(visualization)}
              className="p-2 rounded-lg bg-bill-100 text-bill-700 hover:bg-bill-200 transition-colors"
              title="Edit"
            >
              <Edit2 className="w-4 h-4" />
            </button>
            <button
              onClick={() => onDelete && onDelete(visualization.id)}
              className="p-2 rounded-lg bg-red-50 text-red-600 hover:bg-red-100 transition-colors"
              title="Delete"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        )}
      </div>

      {/* Chart */}
      <div className="w-full overflow-x-auto">
        {renderChart()}
      </div>
    </motion.div>
  );
};

export default ChartContainer;
